import { useState } from "react";
import { NotificationManager } from "react-notifications";
import { getErrorFromResponse } from "../../../../../../../../utility/utils";
import { CierresMensualesProduccionApi } from "../../../api/CierresMensualesProduccionApi";
import {
    CAMPOS_DIFERENCIA_ACOPIO,
    TIPO_DIFERENCIA_MANUAL,
} from "../../../helpers/tiposDiferenciaAcopio";

const esVacio = (valor) => valor === null || valor === undefined;

// Las diferencias de los periodos compartidos con otros productos padre se
// escriben en la tabla y se guardan juntas. Al guardarlas se vuelve a consultar
// el cierre, porque cambian el comparativo y quitan el motivo que impedía cerrar
export const useDiferenciasAcopio = (hook) => {
    const periodos = hook.comparativo.diferencias_acopio_por_periodo;

    const periodosManuales = periodos.filter(
        (periodo) => periodo.tipo_diferencia_acopio === TIPO_DIFERENCIA_MANUAL,
    );

    const { guardarDiferenciasAcopio, cargando } =
        CierresMensualesProduccionApi();

    // se arranca con lo que ya estaba guardado
    const [valores, setValores] = useState(() => {
        const iniciales = {};

        periodosManuales.forEach((periodo) => {
            iniciales[periodo.periodo_id] = {};

            CAMPOS_DIFERENCIA_ACOPIO.forEach((campo) => {
                iniciales[periodo.periodo_id][campo] = periodo[campo];
            });
        });

        return iniciales;
    });

    const CambiarValor = (periodoId, campo, valor) => {
        setValores((anteriores) => ({
            ...anteriores,
            [periodoId]: { ...anteriores[periodoId], [campo]: valor },
        }));
    };

    const GuardarDiferencias = async () => {
        const faltaAlguna = periodosManuales.some((periodo) =>
            CAMPOS_DIFERENCIA_ACOPIO.some((campo) =>
                esVacio(valores[periodo.periodo_id][campo]),
            ),
        );

        if (faltaAlguna) {
            NotificationManager.warning(
                "Ingrese la diferencia de laboratorio y la de liquidación de " +
                    "todos los periodos compartidos",
                "Advertencia",
                3000,
            );
            return;
        }

        try {
            await guardarDiferenciasAcopio({
                padre_producto_terminado_id:
                    hook.filtros.padre_producto_terminado_id,
                diferencias: periodosManuales.map((periodo) => ({
                    periodo_id: periodo.periodo_id,
                    ...valores[periodo.periodo_id],
                })),
            });

            NotificationManager.success(
                "Diferencias acopio guardadas correctamente",
                "Éxito",
                3000,
            );

            hook.recargarConsulta();
        } catch (error) {
            NotificationManager.error(
                getErrorFromResponse(
                    error,
                    "Error al guardar las diferencias acopio",
                ),
                "Error",
                3000,
            );
        }
    };

    return {
        periodos,
        hayPeriodosManuales: periodosManuales.length > 0,
        valores,

        cambiarValor: CambiarValor,
        guardarDiferencias: GuardarDiferencias,

        cargando,
    };
};
